export default "__VITE_ASSET__bfaec805__"